/**
 * Adds an alpha channel to a hex color using 8-digit hex format (#RRGGBBAA)
 * @param color - The color string (hex, rgb, or CSS variable format)
 * @param opacity - The opacity value between 0 and 1
 * @returns The color with alpha channel in 8-digit hex format, or undefined if conversion fails
 */
export function hexOpacity(color: string, opacity: number): string | undefined {
  const alphaHex = Math.round(opacity * 255)
    .toString(16)
    .padStart(2, '0');

  // Handle CSS variable format: rgba(var(--custom-constantBlue-rgb),1)
  if (color.includes('var(')) {
    // Replace the alpha value in the rgba() function
    return color.replace(/,\s*[\d.]+\s*\)$/, `,${opacity})`);
  }

  if (color.startsWith('rgb')) {
    // Parse rgb(r, g, b) and convert to #RRGGBBAA
    const match = color.match(/\d+/g);
    if (match && match.length >= 3) {
      const [r, g, b] = match.map(Number);
      return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}${alphaHex}`;
    }
  } else if (color.startsWith('#')) {
    // Append alpha to existing hex color
    const hex =
      color.length === 4
        ? `#${color[1]}${color[1]}${color[2]}${color[2]}${color[3]}${color[3]}`
        : color;
    return `${hex}${alphaHex}`;
  }

  return undefined;
}
